import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { getLocalItem, setLocalItem } from '@prosaas/psw-utils';
import { Logo, NavCollapser, NavContainer, NavLink } from '@prosaas/psw-styleguide';
import { useSidebarItems } from '../hooks/useSidebarItems';
import { navigationTestIds } from '../testIds';

const IS_SIDEBAR_CLOSED = 'isSidebarClosed';

export const Sidebar: React.FC = () => {
  const location = useLocation();

  const [isSidebarClosed, setIsSidebarClosed] = useState<boolean>(getLocalItem(IS_SIDEBAR_CLOSED) ?? false);
  const toggleSidebarCollapsed = () => {
    const newSidebarState = !isSidebarClosed;
    setLocalItem(IS_SIDEBAR_CLOSED, newSidebarState);
    setIsSidebarClosed(newSidebarState);
  };

  const isActive = (appName: string): boolean => location.pathname.startsWith(`/${appName}`);

  const { sidebarItemList, isAuthorized } = useSidebarItems();

  if (!isAuthorized) return null;
  if (sidebarItemList.length === 0) return null;

  return (
    <NavContainer isSidebarClosed={isSidebarClosed}>
      <Logo isMinimized={isSidebarClosed} />

      {sidebarItemList.map(({ href, appName, displayName, iconUrl, permissions }) => (
        <Link key={href} to={href} style={{ width: '100%' }}>
          <NavLink
            displayName={displayName}
            iconUrl={iconUrl}
            isActive={isActive(appName)}
            permissions={permissions}
            isMinimized={isSidebarClosed}
            testId={navigationTestIds.sidebarOption}
          />
        </Link>
      ))}

      <NavCollapser isSidebarClosed={isSidebarClosed} onClick={toggleSidebarCollapsed} />
    </NavContainer>
  );
};
